import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgCardGift3 = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke='#fff'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M22 17V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2Z'
      opacity={0.6}
    />
    <path
      fill='#fff'
      d='M5 11.5a1 1 0 1 0 0-2zm14-2a1 1 0 1 0 0 2zm-14 0H3v2h2zm16 0h-2v2h2z'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='m9.035 12.244 5.93-3.488a2.02 2.02 0 0 1 2.388.247v0a2.024 2.024 0 0 1 0 2.995v0a2.02 2.02 0 0 1-2.388.246l-5.93-3.488a2.02 2.02 0 0 0-2.388.247v0a2.024 2.024 0 0 0 0 2.995v0a2.02 2.02 0 0 0 2.388.246'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='m10 14.5 2-4 2 4'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgCardGift3)
export default ForwardRef
